import { useForm as useRcFormInstance } from 'rc-field-form';
import { Form } from './form';
import { FormItem } from './form-item';
import { useForm, useFormItem } from './hooks';
const ExportForm = Form;
ExportForm.useForm = useForm;
ExportForm.useFormItem = useFormItem;
ExportForm.useFormInstance = useRcFormInstance;
export { ExportForm as Form, FormItem, useForm, useRcFormInstance as useFormInstance, useFormItem };
